var _clipPath, _clipPath2, _clipPath3, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 450",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-845.32,-1700.89)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252,412.889L279,439.889L279,511.889L207,511.889L207,412.889L252,412.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207,511.889L207,412.889L279,412.889L279,511.889L207,511.889Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252,412.889L279,439.889L279,511.889L207,511.889L207,412.889L252,412.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(5,65,93)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.251,436.024L257.251,437.888C257.764,437.936 258.364,438.002 259.053,438.087C259.744,438.173 260.306,438.285 260.739,438.425C261.251,438.597 261.658,438.798 261.961,439.031C262.264,439.264 262.415,439.544 262.415,439.87C262.415,440.415 262.322,441.06 262.136,441.806C261.949,442.552 261.7,443.475 261.39,444.579C260.861,446.382 260.212,448.55 259.443,451.083C258.673,453.616 257.645,456.879 256.355,460.872L247.647,436.024L242.7,436.024L235.161,460.107C233.498,455.093 232.098,450.893 230.964,447.508C229.829,444.124 229.076,441.828 228.703,440.616C228.641,440.353 228.582,440.119 228.528,439.917C228.474,439.716 228.446,439.505 228.446,439.288C228.446,439.179 228.478,439.054 228.54,438.915C228.602,438.775 228.773,438.643 229.052,438.518C229.347,438.393 229.75,438.273 230.261,438.157C230.773,438.04 231.548,437.92 232.588,437.796L232.588,436.024L214.941,436.024L214.941,437.842C215.563,437.92 216.111,438.024 216.584,438.157C217.057,438.289 217.505,438.495 217.925,438.775C218.515,439.163 218.997,439.548 219.37,439.929C219.743,440.309 220.077,440.919 220.372,441.759C221.32,444.524 222.485,447.949 223.869,452.027C225.252,456.106 227.241,461.923 229.837,469.477L234.541,469.477L242.41,444.903L251.12,469.477L255.83,469.477C257.756,463.866 259.61,458.458 261.39,453.251C263.169,448.045 264.487,444.261 265.341,441.899C265.59,441.215 265.865,440.632 266.169,440.149C266.472,439.669 266.98,439.226 267.695,438.822C268.162,438.573 268.636,438.366 269.118,438.204C269.599,438.04 270.081,437.936 270.563,437.888L270.563,436.024L257.251,436.024Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.663,445.303L242.752,408.213L279.923,445.384L242.834,482.474L205.663,445.303Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252,439.889L279,439.889L252,412.889L252,439.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.5,426.389L252,412.889L279,439.889L265.5,453.389L238.5,426.389Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252,412.889L279,439.889L252,439.889L252,412.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "bevel",
      stroke: "rgb(5,65,93)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "213px",
    y: "503.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "white"
    }
  }, "D", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "232.521px 253.6px ",
    y: "503.889px 503.889px "
  }, "OC"))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-98.9995,98.9995,-4.3e-06,243,511.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,44,68)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(18,129,178)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(37.0893,-37.0893,37.0893,37.0893,224.248,463.888)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,97,134)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.5003,-13.5003,13.5003,13.5003,252,439.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(223,242,251)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    style: {
      stopColor: "rgb(176,196,214)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    style: {
      stopColor: "rgb(43,97,131)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(12,86,121)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsword);
export default __webpack_public_path__ + "static/media/msword.4f395fd3d09d918d34392ba0096b9ad7.svg";
export { ForwardRef as ReactComponent };